import { observer } from 'mobx-react';
import * as React from 'react';
import Store from './Store';
import Button from '../../../../../Form/Button';

interface Props {
  store: Store;
}

const ModalTrigger: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'waiting':
      return <></>;
    case 'waiting-with-link':
    case 'loading':
    case 'loading-error':
    case 'showing':
    case 'hiding':
    case 'selecting':
      return (
        <Button
          type="button"
          value="Add programs"
          className="ml-3 rounded-md bg-teal-600 px-5 py-2 text-white"
          onClick={store.openModal}
        />
      );
  }
};

export default observer(ModalTrigger);
